import React,{Component} from 'react';
import '../../CSS/style.css';
import { Icon } from 'antd';

export default class SlidersArrows extends Component{
    render(){
        return (
            <div
                className="arrows"
                style={{ zIndex: 3 }}
            >
                <span
                    className="arrow arrow-left"
                    onClick={()=>this.props.turn(-1)}
                >
                    {/*&lt;*/}
                    <Icon type="left"  style={{fontSize: 50}}/>
                </span>
                <span
                    className="arrow arrow-right"
                    onClick={()=>this.props.turn(1)}
                >
                    {/*&gt;*/}
                    <Icon type="right" style={{fontSize: 50}}/>
                </span>
            </div>
        )
    }
}